export default __webpack_public_path__ + "static/media/play_black.47c5a0b3.svg";